import { LookupCodes } from 'src/constants/lookup.constants';

export function getLookupCodeLabelFor(lookupCode: string | LookupCodes, isNewEditor = false): LookupCodes {
  if (!isNewEditor && lookupCode === LookupCodes.PASSEPARTOUT) {
    // TODO: remove this when we remove the old editor
    // we do this for quadretti adesivi - UES-887
    return LookupCodes.LAYOUT;
  } else {
    return lookupCode as LookupCodes;
  }
}
